import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StorytellingSection.css';

function StorytellingSection() {
  const navigate = useNavigate();

  const handleCTAClick = () => {
    navigate('/login');
  };

  return (
    <section className="usecases-section-new" id="use-cases">
      <div className="usecases-bg-orb"></div>
      <div className="usecases-bg-mesh"></div>

      <div className="usecases-container-new">
        <div className="usecases-header-section">
          <div className="usecases-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="1.5"/>
            </svg>
            Use Cases
          </div>
          <h2 className="usecases-main-heading">Intelligent & Evidence-Based Medical Learning</h2>
          <p className="usecases-subheading">
            Discover how medical professionals leverage S.C.A.L.P.E.L. to transform their learning experience
          </p>
        </div>

        <div className="usecases-cards-grid">
          {/* Card 1 - Exam Preparation */}
          <div className="usecase-card-new" data-index="1">
            <div className="card-glow-effect"></div>
            <div className="usecase-icon-box">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </div>
            <h3 className="usecase-card-title">Exam Preparation Excellence</h3>
            <p className="usecase-card-desc">Master USMLE, NEET-PG, and PLAB with AI-powered practice questions and adaptive learning paths.</p>
            <div className="usecase-stats">
              <div className="mini-stat">
                <span className="mini-value">85%</span>
                <span className="mini-label">Success Rate</span>
              </div>
              <div className="mini-stat">
                <span className="mini-value">10K+</span>
                <span className="mini-label">Questions</span>
              </div>
            </div>
          </div>

          {/* Card 2 - Clinical Practice */}
          <div className="usecase-card-new" data-index="2">
            <div className="card-glow-effect"></div>
            <div className="usecase-icon-box">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </div>
            <h3 className="usecase-card-title">Clinical Practice Support</h3>
            <p className="usecase-card-desc">Quick reference for diagnosis, treatment guidelines, and evidence-based decision making at point of care.</p>
            <div className="usecase-metric">
              <span className="metric-number">40%</span>
              <span className="metric-label">Faster Diagnosis</span>
            </div>
          </div>

          {/* Card 3 - Research */}
          <div className="usecase-card-new" data-index="3">
            <div className="card-glow-effect"></div>
            <div className="usecase-icon-box">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M9 11L12 14L22 4" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </div>
            <h3 className="usecase-card-title">Research & Learning</h3>
            <p className="usecase-card-desc">Access latest medical literature and research papers instantly with AI summarization.</p>
            <div className="usecase-metric">
              <span className="metric-number">30%</span>
              <span className="metric-label">Better Retention</span>
            </div>
          </div>

          {/* Card 4 - Case Studies */}
          <div className="usecase-card-new" data-index="4">
            <div className="card-glow-effect"></div>
            <div className="usecase-icon-box">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M8 15C12.8747 15 15 12.949 15 8C15 12.949 17.1104 15 22 15C17.1104 15 15 17.1104 15 22C15 17.1104 12.8747 15 8 15Z" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M2 6.5C5.13376 6.5 6.5 5.18153 6.5 2C6.5 5.18153 7.85669 6.5 11 6.5C7.85669 6.5 6.5 7.85669 6.5 11C6.5 7.85669 5.13376 6.5 2 6.5Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </div>
            <h3 className="usecase-card-title">Case Studies</h3>
            <p className="usecase-card-desc">Interactive patient cases with detailed workflows for hands-on learning.</p>
            <div className="usecase-metric">
              <span className="metric-number">100+</span>
              <span className="metric-label">Daily Cases</span>
            </div>
          </div>

          {/* Card 5 - Medical Q&A */}
          <div className="usecase-card-new" data-index="5">
            <div className="card-glow-effect"></div>
            <div className="usecase-icon-box">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </div>
            <h3 className="usecase-card-title">Medical Q&A</h3>
            <p className="usecase-card-desc">Instant AI-powered answers backed by evidence and clinical guidelines.</p>
            <div className="usecase-metric">
              <span className="metric-number">24/7</span>
              <span className="metric-label">Available</span>
            </div>
          </div>

          {/* Card 6 - Study Resources */}
          <div className="usecase-card-new" data-index="6">
            <div className="card-glow-effect"></div>
            <div className="usecase-icon-box">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </div>
            <h3 className="usecase-card-title">Comprehensive Study Resources</h3>
            <p className="usecase-card-desc">Access study guides, flashcards, summaries, and videos tailored to your learning needs.</p>
            <div className="resource-tags">
              <span className="resource-tag">Flashcards</span>
              <span className="resource-tag">Guides</span>
              <span className="resource-tag">Videos</span>
            </div>
          </div>
        </div>

        <div className="usecases-cta-wrapper">
          <button className="usecases-cta-btn" onClick={handleCTAClick}>
            <span>Start Learning Free</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M7 17L17 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M7 7H17V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}

export default StorytellingSection;
